<template>
  <div
    id="tabs"
    class="tabs is-boxed pt-0 mb-0"
    data-target="tabContent"
  >
    <ul>
      <template
        v-for="(tab, index) in tabs"
        :key="'tab' + index"
      >
        <li
          :class="{'is-active': index === tabIndex}"
          @click="stepValidation(index)"
        >
          <div class="label">
            {{ $t('rawdata.step') }} {{ index + 1 }}
          </div>
          <a :aria-label="tab + 'Tab'">{{ tab }}</a>
        </li>
      </template>
    </ul>
  </div>
  <div
    id="tabContent"
    ref="scrollToElement"
    class="tabContent"
  >
    <template
      v-for="(err, index) in errorMessage"
      :key="index"
    >
      <span class="errorMessage pt-3">{{ $t('rawdata.tabs.message.' + err) }}</span>
    </template>
    <template
      v-for="(tab, index) in tabs"
      :key="'tab' + index"
    >
      <div
        :class="{'hide': tabIndex !== index, 'activeTab': tabIndex === index}"
      >
        <slot :name="'step' + (index+1)" />
      </div>
    </template>
    <div
      v-show="tabIndex < tabs.length - 1"
      class="text-right"
    >
      <hr>
      <template
        v-for="(err, index) in errorMessage"
        :key="index"
      >
        <span class="errorMessage">{{ $t('rawdata.tabs.message.' + err) }}</span>
      </template>
      <p>
        <a
          class="button  is-brightGreen is-outlined "
          aria-label="Next Step"
          @click="stepValidation(tabIndex + 1)"
        >Next Step</a>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { rawdataState } from '@/composables/state/rawdataApp';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const {
  validation,
  errorMessage
} = rawdataState();

const tabIndex = ref<number>(0);
const scrollToElement = ref<HTMLInputElement | null>(null);

const scrollToTabTop = () => {
  const element = document.querySelector('.tabs');
  if (element) {
    // Calculate the position to scroll to taking into account the offset
    const offset = 100;
    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({
      top: elementPosition,
      behavior: 'smooth'
    });
  }
};

const { tm } = useI18n();

const tabs:string[] = [];
for (let i = 1; i <= 3; i++) {
  tabs.push(tm('rawdata.tabs.tab' + (i) + '.tabName'));
}

const stepValidation = (index: number) => {
  /* do nothing when it is same tab */
  if (index === tabIndex.value) {
    return;
  }
  /* when go back to prev tabs */
  if (index < tabIndex.value) {
    tabIndex.value = index;
    scrollToTabTop();
    return;
  }
  /* when move to next tab, do validation */
  if (validation(tabIndex.value)) {
    tabIndex.value = index;
    scrollToTabTop();
  }
};

</script>
<style lang="scss" scoped>

.tabContent {
  box-shadow: 0 4px 30px #00000014;
  padding: 20px;
  top: 0;

  >div.hide {
    display: none;
  }
}
/* .tabContent {
  padding-left: 30px;
  padding-right: 30px;
  background-color: white;
} */
.errorMessage {
  color:rgb(255, 115, 0);
}

a {
  cursor: pointer;
}

@media screen and (min-width: 1024px) {
  /* #tabs {
    width: 70%;
    margin: 0 auto;
  }
  .tabContent {
    padding-left: 15%;
    padding-right: 15%;
  } */
}
.text-right {
  text-align: right;
}
</style>
